import { SelectItem } from '@justgiving/select';
import { TFunction } from 'i18next';
import {
  FitnessApplicationActivityType,
  MeasurementSystem,
} from '../../../../../types/__generated__';
import { UnitOfMeasure } from '../Helpers//ConversionHelpers';
import { TimePeriod } from '../Helpers/TimeHelpers';

export const getTimePeriods = (t: TFunction, now: Date) => [
  {
    isSelected: now.getHours() < 12,
    label: t('manualFitness.activityTime.period.am'),
    value: TimePeriod.AM,
  },
  {
    isSelected: now.getHours() >= 12,
    label: t('manualFitness.activityTime.period.pm'),
    value: TimePeriod.PM,
  },
];

export const getActivityTypes = (
  t: TFunction,
  subscribedActivities: FitnessApplicationActivityType[],
): Array<SelectItem & {
  value: FitnessApplicationActivityType;
}> =>
  [
    {
      isSelected: false,
      label: t('manualFitness.activityType.run'),
      value: FitnessApplicationActivityType.Run,
    },
    {
      isSelected: false,
      label: t('manualFitness.activityType.ride'),
      value: FitnessApplicationActivityType.Ride,
    },
    {
      isSelected: false,
      label: t('manualFitness.activityType.walk'),
      value: FitnessApplicationActivityType.Walk,
    },
    {
      isSelected: false,
      label: t('manualFitness.activityType.swim'),
      value: FitnessApplicationActivityType.Swim,
    },
    {
      isSelected: false,
      label: t('manualFitness.activityType.wheelchair'),
      value: FitnessApplicationActivityType.Wheelchair,
    },
  ].filter(activity =>
    subscribedActivities.some(
      subscribedActivity => subscribedActivity === activity.value,
    ),
  );

export const getUnitsOfMeasure = (
  t: TFunction,
  measurment: 'distance' | 'elevation',
  measurementSystem: MeasurementSystem,
): Array<SelectItem & {
  value: UnitOfMeasure;
}> =>
  [
    {
      isSelected: false,
      label: t('manualFitness.unitOfMeasure.kilometers'),
      value: UnitOfMeasure.Kilometers,
    },
    {
      isSelected: false,
      label: t('manualFitness.unitOfMeasure.miles'),
      value: UnitOfMeasure.Miles,
    },
    {
      isSelected: false,
      label: t('manualFitness.unitOfMeasure.meters'),
      value: UnitOfMeasure.Meters,
    },
    {
      isSelected: false,
      label: t('manualFitness.unitOfMeasure.feet'),
      value: UnitOfMeasure.Feet,
    },
  ]
    .filter(unit =>
      measurment === 'distance'
        ? [
            UnitOfMeasure.Kilometers,
            UnitOfMeasure.Miles,
            UnitOfMeasure.Meters,
          ].some(allowedUnit => allowedUnit === unit.value)
        : [UnitOfMeasure.Meters, UnitOfMeasure.Feet].some(
            allowedUnit => allowedUnit === unit.value,
          ),
    )
    .map(unit => {
      if (measurment === 'distance') {
        unit.isSelected =
          measurementSystem === MeasurementSystem.Imperial
            ? unit.value === UnitOfMeasure.Miles
            : unit.value === UnitOfMeasure.Kilometers;
      } else {
        unit.isSelected =
          measurementSystem === MeasurementSystem.Imperial
            ? unit.value === UnitOfMeasure.Feet
            : unit.value === UnitOfMeasure.Meters;
      }

      return unit;
    });
